'use client';

import { useI18n } from '@/contexts/I18nContext';

import { BarChart3, Film, Search } from 'lucide-react';

// Три режима работы Canny. Карточки объясняют, что он умеет, лучше любого
// онбординга — тот же приём, что в Cursor.
export const CANNY_STARTERS = [
  { key: 'business', Icon: Search },
  { key: 'video', Icon: Film },
  { key: 'campaign', Icon: BarChart3 },
] as const;

interface CannyEmptyStateProps {
  onPick: (prompt: string) => void;
}

export function CannyEmptyState({ onPick }: CannyEmptyStateProps) {
  const { t } = useI18n();
  return (
    <div className="mt-4 w-full max-w-2xl">
      <div className="flex flex-col gap-2 text-start">
        {CANNY_STARTERS.map(({ key, Icon }) => (
          <button
            key={key}
            type="button"
            onClick={() => onPick(t(`canny.starter.${key}.prompt`))}
            className="liquid-glass group flex items-center gap-3 rounded-2xl px-4 py-3 transition-colors hover:bg-white/5"
          >
            <Icon className="h-4 w-4 shrink-0 text-white/50 transition-colors group-hover:text-white/80" />
            <span className="text-sm text-white/85">{t(`canny.starter.${key}.title`)}</span>
            <span className="truncate text-xs text-white/40">{t(`canny.starter.${key}.hint`)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
